module.exports = __webpack_public_path__ + "img/hotel1.95c03524.png";